import { useNavigate } from 'react-router-dom';

import { PrimaryButton } from '../components/button/PrimaryButton';
import { InfoPopover } from '../components/InfoPopover';
import { t } from '../services/translation/translation';

export const HomeRoute = () => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col gap-y-4 p-4 h-96 items-center">
      <div className="flex flex-col gap-y-2 max-w-xl w-full">
        <div className="flex items-center gap-2">
          <h2 className="text-2xl font-bold  text-center sm:text-left">{t('home-route.da-title')}</h2>
          <InfoPopover text={t('home-route.da-info')} />
        </div>
        <div className="flex gap-x-4 items-center gap-y-2 justify-between flex-col sm:flex-row">
          <div className="flex-1">
            <p>{t('home-route.da-description')}</p>
          </div>
          <PrimaryButton onClick={() => navigate('/booker')} text={t('home-route.da-button')} />
        </div>
      </div>
    </div>
  );
};
